import { translate } from "../../../../infrastructure/translate/localization";

const legends = [
  {
    id: 0,
    text: translate("upload-employees-section.modal-legend-all-people"),
  },
  {
    id: 1,
    text: translate("upload-employees-section.modal-legend-structure-message"),
  },
  {
    id: 2,
    text: translate("upload-employees-section.modal-legend-name"),
  },
  {
    id: 3,
    text: translate("upload-employees-section.modal-legend-surname"),
  },
  {
    id: 4,
    text: translate("upload-employees-section.modal-legend-second-surname"),
  },
  {
    id: 5,
    text: translate("upload-employees-section.modal-legend-email"),
  },
  {
    id: 6,
    text: translate("upload-employees-section.modal-legend-nif"),
  },
  {
    id: 7,
    text: translate("upload-employees-section.modal-legend-salary"),
  },
  {
    id: 6,
    text: translate("upload-employees-section.modal-legend-hiring-date"),
  },
];

export default legends;
